<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
<!--                            buat dialog dengan input tanggal-->
                            <Dialog header="Upload SK DRM" :visible="displayBasic" :modal="true" :closable="false" :style="{ width: '50vw' }">
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="tanggal"
                                            value="Tanggal "
                                        />
                                        <Input
                                            id="tanggal"
                                            v-model="tanggal"
                                            type="datetime-local"
                                            placeholder=""
                                            class="mt-1 block w-full"
                                        />
                                    </div>
                                </div>
                                <div class="p-fluid px-3 mb-3">
                                    <div class="p-field">
                                        <JetLabel
                                            class="w-full"
                                            for="sk_drm"
                                            value="SK DRM (PDF) Max 2MB"
                                        />
                                        <Input
                                            type="file"
                                            class="mt-1 block w-full"
                                            accept="application/pdf"
                                            v-on:change="onChangeFileUpload($event)"
                                        />
                                    </div>
                                </div>
                                <template #footer>
                                    <div class="p-d-flex p-jc-end">
                                        <Button label="Batal" @click="displayBasic=false" />
                                        <Button label="Tetapkan" @click="buatDaftar" />
                                    </div>
                                </template>
                            </Dialog>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonAdd
                                            :disabled="
                                                selected_penyedia.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Buat DRM"
                                            @click="buat($event)"
                                            class="mr-1"
                                            v-if="$page.props.session_role?.role?.name == 'adminkpbj'"
                                        />
                                    </template>
                                    <template #end>
                                    </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedpenyedia"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
        ButtonEdit,
        ButtonAdd,
        Dialog,
        JetLabel,
        Input,
    },
    data() {
        return {
            sk_drm: '',
            ezdtConfig: {
                dtHeader: "Daftar Penyedia",
                globalFilter: ["nama_perusahaan"],
                sortBy: "created_at",
                defineCols: [
                    {
                        field: "status",
                        header: "Status",
                        style: "min-width: 5rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "nama_perusahaan",
                        header: "Nama",
                        style: "min-width: 20rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "npwp_perusahaan",
                        header: "NPWP",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_jenis_pekerjaan",
                        header: "Jenis Pekerjaan",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_pemberi_kuasa",
                        header: "Direktur",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_penerima_kuasa",
                        header: "Nama Penerima Kuasa",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "alamat_perusahaan",
                        header: "Alamat",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "alamat_perusahaan_semarang",
                        header: "alamat_perusahaan_semarang",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },

                ],
                dtSourceApiRoute: {
                    list: "penyedia.dataRekananMampu",
                    show: "penyedia.show",
                    // edit: "penyedia.edit",
                    // destroy: "penyedia.destroy",
                },
            },
            selected_penyedia: [],
            selected_penyedia_id: 0,
            allow_to_proceed: true,
            displayBasic: false,
            tanggal: null,
            keterangan: null,
            lokasi: null,
        };
    },
    methods: {
        loadEzData: function () {
            // this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelectedpenyedia: function (data) {
            this.selected_penyedia = data;
            this.selected_penyedia_id = 0;
            if (data.length == 1) {
                this.selected_penyedia_id = data[0]["user_id"];
                console.log(this.selected_penyedia_id);
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },

        onChangeFileUpload(event){
            this.sk_drm = event.target.files[0];
            console.log(this.sk_drm);
        },
        buat: function (event) {

            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            // tampilkan modal
            this.displayBasic = true;

        },
        buatDaftar: function (event) {
            let ids = [];
            this.selected_penyedia.forEach(function (item, index) {
                ids.push(item.id);
            });
            let formData = new FormData();
            formData.append('ids', ids);
            formData.append('tanggal', this.tanggal);
            formData.append('sk_drm', this.sk_drm);

            // update data
            // console.log(this.tanggal);
           axios
               .post(route("penyedia.buatDrm"), formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    if(response.data.stts == 'ok'){
                        this.$toast.add({
                            severity: "success",
                            summary: "Success",
                            detail: response.data.msg,
                            life: 3000,
                        });
                        // redirect inertia /penyedia/daftarRekananMampu
                        this.$inertia.visit('/penyedia/daftarRekananMampu');
                    }else{
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: response.data.msg,
                            life: 3000,
                        });

                    }

                    // this.loadEzData();
                    //redirect kehalaman response.url
                    // window.location.href = response.data.url;
                    // console.log(response.data);
                    this.displayBasic = false;
                })
                .catch((error) => {
                    // console.log(error);
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: response.data.msg,
                        life: 3000,
                    });

                });

        },
    },
});
</script>
